import { 
    otp_new_create,
    otp_get_mobile,
    otp_update_status
} from '../Models/otp';

//====== ON CREATE TASKS DATA ======
export const onCreateNewOTP = (data) => {
    return new Promise((resolve, reject) => {
        otp_new_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onGetOtpByMobile = (data) => {
    return new Promise((resolve, reject) => {
        otp_get_mobile(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onUpdateOtpStatus = (data) => {
    return new Promise((resolve, reject) => {
        otp_update_status(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}